/**
 * Privacy and terms, as pages, so the footer can link to them. They are not policies, and they say what is true today. Inventing
 * legal copy before counsel writes it would be a lie on a page whose job is to tell the truth.
 */
import * as stylex from "@stylexjs/stylex";
import { useEffect } from "react";
import "@lattice/tokens/color.stylex";
import { color } from "@lattice/tokens/color.stylex";
import "@lattice/tokens/space.stylex";
import { space } from "@lattice/tokens/space.stylex";
import "@lattice/tokens/text.stylex";
import { text } from "@lattice/tokens/text.stylex";
import { SiteFooter, SiteHeader } from "./Site.tsx";
const GUTTER = "clamp(20px, 4vw, 56px)";
const COPY = {
  privacy: {
    title: "Privacy",
    documentTitle: "Privacy · Lattice Nutrition",
    lead: "No privacy policy is published yet.",
    body: "Until one is, we use your labs to draft your formula and for your physician to review it, and we do not sell them."
  },
  terms: {
    title: "Terms",
    documentTitle: "Terms · Lattice Nutrition",
    lead: "No terms of service are published yet.",
    body: "Until they are, write to us with any question about your account or order."
  }
} as const;
function Placeholder({
  kind
}: {
  readonly kind: "privacy" | "terms";
}) {
  const copy = COPY[kind];
  useEffect(() => {
    document.title = copy.documentTitle;
  }, [copy.documentTitle]);
  return <div className="x1ov3xa9 x78zum5 xdt5ytf x1l0w1cl xzb3lse x1cikjda x1rf3zrh xbz0q3o xvmahel">
      <div className="x80co2b xvueqy4 xelt9ym xh8yej3 x1iyjqo2">
        <SiteHeader />
        <main className="x78zum5 xdt5ytf x1r0x45p x19pysoa xgs5mw1">
          <h1 className="x1ghz6dp x1u29x3t xqu410z x1ntj4s9 x1d3j7mx x1e5flnj x1w2vvpw">{copy.title}</h1>
          <p className="x1ghz6dp x1jty25b x1fzhlzt">{copy.lead}</p>
          <p className="x1ghz6dp x1jty25b x1fzhlzt">{copy.body}</p>
        </main>
      </div>
      <SiteFooter />
    </div>;
}
export function Privacy() {
  return <Placeholder kind="privacy" />;
}
export function Terms() {
  return <Placeholder kind="terms" />;
}